import { Component, computed, inject, input, model, signal } from '@angular/core';
import { TasksService } from '@app/shared/services/tasks/tasks.service';
import { SimpleProperty } from '@core';
import { AlertComponent, Checklist, ChecklistBuilderComponent } from '@ui';

@Component({
  selector: 'sbnb-add-task-rule-flow-checklist',
  standalone: true,
  templateUrl: './add-task-rule-flow-checklist.component.html',
  imports: [ChecklistBuilderComponent, AlertComponent],
})
export class AddTaskRuleFlowChecklistComponent {
  readonly #taskService = inject(TasksService);

  property = input.required<SimpleProperty>();
  checklist = model<Checklist>({ groups: [] });

  generatingChecklist = signal<boolean>(false);

  readonly alertAction = computed(() => {
    return {
      label: 'Auto-generate',
      loading: this.generatingChecklist(),
      loadingLabel: 'Generating...',
      onClick: () => {
        this.#generateAiChecklist();
      },
    };
  });

  #generateAiChecklist() {
    this.generatingChecklist.set(true);
    this.#taskService.generateChecklistForProperty(this.property().id).subscribe(
      (checklist) => {
        this.checklist.set(checklist);
        this.generatingChecklist.set(false);
      },
      () => {
        this.generatingChecklist.set(false);
      }
    );
  }
}
